import React, { useCallback, useMemo } from 'react';
import { isSafari } from 'react-device-detect';
import PropTypes from 'prop-types';
import { getIsFieldRequired } from 'utils';

import { PasswordInput } from '@atlas/ui';

import Field from 'common/Form/Field';

const TextField = ({ field, onBlur = () => {}, onChange, onFocus = () => {} }) => {
  const { active, autofocus, disabled, errors, label, name, placeholder, rules, touched, value } =
    field;

  const inputValue = value ?? '';
  const changeHandler = useCallback(event => onChange(event.target.value), [onChange]);

  const error = touched && errors[0];
  const isRequiredSymbol = useMemo(() => getIsFieldRequired(rules), [rules]);

  return (
    <Field className="field-password" isSignupForm options={field}>
      <PasswordInput
        active={active}
        autoComplete={field.autocomplete}
        autoFocus={autofocus}
        disabled={disabled}
        error={error}
        isRequiredSymbol={isRequiredSymbol}
        isTypeText={isSafari}
        label={label}
        name={name}
        onBlur={onBlur}
        onChange={changeHandler}
        onFocus={onFocus}
        placeholder={placeholder}
        touched={touched}
        value={inputValue}
      />
    </Field>
  );
};

TextField.propTypes = {
  field: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

export default TextField;
